define('models/accounts/accounts',[
    'backbone',
    'models/accounts/bank',
    'models/accounts/accountmodel'
], function(Backbone, BankModel, AccountModel){
    var Accounts = Backbone.Model.extend({
        urlRoot: function(){

            if(this.instanceURL){
                return this.instanceURL;
            }
            
        },
        initialize: function(options){
            options = options || {};
            this.instanceURL = options.instanceURL;
        },
        parse: function(data){
            var response = {};

            var AccountsModel = Backbone.Collection.extend({
                model: AccountModel
            });

            response = new AccountsModel(data);
            // console.log('Accounts parse',response,data);

            // response.accounts = new AccountsModel(data.accounts, { parse: true, });
            // response.bank = new BankModel(data.bank, { parse: true, });
            
            return response;
        },

        save: function(options){
            options = options || {};

            var data = {};

            data.account_id = this.attributes.account_id;
            data.account_name = this.attributes.account_name;
            data.target_amount = this.attributes.target_amount;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, this.attributes, options);
        }
    });
    return Accounts;
});

